import { z } from 'zod';

export const productStoryImageSchema = z.object({
  id: z.number().optional(),
  user_id: z.number().optional(),
  product_story_id: z.number().optional(),
  file_id: z.number().optional(),
  url: z.string(),
  no: z.number(),
  is_hidden: z.boolean().default(false),
  created_at: z.string().datetime().nullable().default(null),
  updated_at: z.string().datetime().nullable().default(null),
});

export const productStorySchema = z.object({
  id: z.number().optional(),
  user_id: z.number().optional(),
  store_id: z.number().optional(),
  title: z.string().nullable().default(null),
  description: z.string().nullable().default(null),
  fb_embed: z.string().nullable().default(null),
  youtube_embed: z.string().nullable().default(null),
  tw_embed: z.string().nullable().default(null),
  ins_embed: z.string().nullable().default(null),
  tiktok_embed: z.string().nullable().default(null),
  is_hidden: z.boolean().default(false),
  created_at: z.string().datetime().nullable().default(null),
  updated_at: z.string().datetime().nullable().default(null),
  title_en: z.string().nullable().default(null),
  title_jp: z.string().nullable().default(null),
  description_en: z.string().nullable().default(null),
  description_jp: z.string().nullable().default(null),
  content: z.string().nullable().default(null),
  _: z.object({
    product_story_images: z.array(productStoryImageSchema).default([]),
  }),
});
